import React, { Component } from 'react';
import {Form} from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import {format as stringFormat} from 'react-string-format';

import { crewFeedbackListAction} from '../../../actions/crewActions';
import { clearAction } from '../../../actions/commonActions';
import Paginator from '../../commons/helpers/paginator';
import Toast from '../../commons/helpers/toast';

import {userGroupUrlCheck,getUserTimeZone} from '../../../utils/userGroupUrlCheck';
import { converDateToLocal,convertDecimalToHHMM } from '../../../utils/commonUtilities';

import * as types from '../../../actions';
import { LBL_SLNUM, LBL_SHIFT_DATE, LBL_COMPLETED_SHIFT_CREWS, LBL_CLIENT, LBL_REVIEWED_BY, LBL_RATING, LBL_REVIEW_COMMENTS, LBL_REVIEW, LBL_HOURS_SHORT, LBL_CHIEF_NOT_AVAIL, LBL_CREW_CHIEF } from '../../../configs/labelConfigs'; 

import { MSG_NOT_FOUND, MSG_SERVER_DATA_FETCH_ERROR } from '../../../configs/msgConfigs'; 
import {URL_IMG} from '../../../configs/urlConfigs';
import {CREW_MAX_RATING,PAGING_END_INDEX,PAGENUMROWS_AFFILIATE,LOGIN_AFFILIATE_GROUP,LOGIN_CLIENT_GROUP} from '../../../configs/staticConfigs';


class CrewFeedback extends Component {

    constructor(props){
        super(props)
        this.state = {
            activePage:1,
            startIndex : 0, 
            endIndex : PAGING_END_INDEX,
            activeRowId:0,    
            perPageCount: PAGENUMROWS_AFFILIATE,
            sortField:'-created_on',
            sortOrder:'', 
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,          
            feedbackShiftList:[],
            selectedTimesheetId:0,
            approvedEventStatus:true,
            actionNeeded:true,
            otLengthError: '',
            noRowsError: '',
            isClientPage:false,
            clientId:0,
            feedbackCrewId: ''       
        }
    }

    setToasterState = (isEnabled,message,isSucces,isAutoHide=true) => {
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        if(isAutoHide){
            setTimeout(()=> {
                this.onCloseToast();
            }, 4000);
        }    
    }

    callToaster = (isEnabled,message,isSucces) => {
        this.props.setToasterState(isEnabled,message,isSucces);
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
    } 

    componentDidUpdate(prevProps){
        const { subactivity, status, errorData, crewFeedbackData} = this.props; 

        if(this.props.crewId && this.state.feedbackCrewId!=this.props.crewId) { 
            this.setState({feedbackCrewId:this.props.crewId}, () => {
                this.callCrewFeedback(); 
            })
        }

        let arrResp = subactivity ? subactivity.split('~~') : []; 
        let actString = arrResp[0] ? arrResp[0] : ''; 
        
        if(actString===types.CREW_FEEDBACK_LIST_SUCCESS){  
            this.setState({feedbackShiftList:crewFeedbackData.results}); 
        }
        else if(actString===types.CREW_FEEDBACK_LIST_ERROR){ 
            this.setToasterState(true,MSG_SERVER_DATA_FETCH_ERROR,false);
        }

    }

    componentDidMount() {
        let userGroupData = userGroupUrlCheck(window.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        if(userGroup===LOGIN_AFFILIATE_GROUP){ 
            this.setState({isClientPage:false});  
        }else if(userGroup===LOGIN_CLIENT_GROUP){
            this.setState({isClientPage:true});  
        }
    }

    callCrewFeedback = () => {
        if(this.props.crewId) { 
            this.props.crewFeedbackListAction({crew_id:this.props.crewId,pageSize:this.state.perPageCount,page:this.state.activePage}); 
        }
    }

   //  onLoadShift = (shiftId,isExpand)=>{
   //      let newFeedObj = {}
   //      let tempObj = this.state.feedbackShiftList;
   //      if(!isExpand){
   //         newFeedObj = tempObj.map(item => {
   //            if(item.shift.id===shiftId) {
   //               item['isExpand'] = true; 
   //            }
   //            else {
   //               item['isExpand'] = false; 
   //            }
   //            return item;
   //         })
   //         this.setState({feedbackShiftList:newFeedObj,expandedShiftId:shiftId}, () => {
   //            // this.props.feedbackDetailsAction({shiftId:shiftId});
   //         }); 
   //      }else{
   //         newFeedObj = tempObj.map(item => {
   //            if(item.shift.id===shiftId) {
   //               item['crews'] = [];
   //               item['isExpand'] = false;
   //            }
   //            return item;
   //         })
   //         this.setState({feedbackShiftList:newFeedObj,expandedShiftId:0});
   //      }
   //   }

   onPagePrevious = (e) =>{
      const {
          startIndex, endIndex        
      } = this.state
      let previousPage = startIndex+1-PAGING_END_INDEX
      this.props.crewFeedbackListAction({crew_id:this.props.crewId,pageSize:this.state.perPageCount,page:previousPage});
      if(startIndex===0){
          this.setState({
              activePage: previousPage,
              startIndex : startIndex,
              endIndex : endIndex
          });  
      }else{
          this.setState({
              activePage: previousPage,
              startIndex : startIndex - PAGING_END_INDEX,
              endIndex : endIndex - PAGING_END_INDEX
          });  
      }                           
   }

   onPageUp = (e) => {
      this.props.crewFeedbackListAction({crew_id:this.props.crewId,pageSize:this.state.perPageCount,page:e.target.id});
      this.setState({
          activePage: Number(e.target.id)                   
      });
   }

   onPageNext = (e) =>{   
      const {
          startIndex,endIndex            
      } = this.state     
      const {
          totalPage            
      } = this.props
             
      let nextPage = startIndex+1+PAGING_END_INDEX;
      this.props.crewFeedbackListAction({crew_id:this.props.crewId,pageSize:this.state.perPageCount,page:nextPage});
      if(endIndex===totalPage || totalPage<=PAGING_END_INDEX){
          this.setState({
              activePage: nextPage,
              startIndex : startIndex,
              endIndex : endIndex
          }); 
      }else{
          this.setState({
              activePage: nextPage,
              startIndex : startIndex + PAGING_END_INDEX,
              endIndex : endIndex + PAGING_END_INDEX
          });  
      }                                   
   }

    render(){

        const {
            activePage,startIndex,endIndex,toastMessage,toastFlag,toastSuccess,isClientPage, feedbackShiftList       
        } = this.state  

        let {crewFeedbackData,totalPage} = this.props;

        let isTimesheetModify = 0; 
        let companyName = ''; 
        if(this.props.hasOwnProperty('showNameInHeader')) companyName = this.props.showNameInHeader;

        let is_active = true; 
        let lbl_chief_no_avai = '';
        let crew_chief_text = ''; 
        let location = window.location; 
        let userGroupData = userGroupUrlCheck(location);
        let userGroup = ''; 
        let profileCurrency = '';
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
            profileCurrency = userGroupData.profile_currency; 
            is_active = userGroupData.is_active; 
            lbl_chief_no_avai = stringFormat(LBL_CHIEF_NOT_AVAIL,userGroupData.supervisor_name); 
            crew_chief_text = userGroupData.supervisor_name; 
        }
        let timeZone =  getUserTimeZone(location);
        
        if(!lbl_chief_no_avai){
            lbl_chief_no_avai = stringFormat(LBL_CHIEF_NOT_AVAIL,'chief'); 
        }
        if(!crew_chief_text){
            crew_chief_text = LBL_CREW_CHIEF; 
        }


        return(
            <React.Fragment>
            <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
             
            <div className="col-md-12">
                <div className="box margin-top-12">
                <div className="box-content">
                     <div className="table-responsive feedback">
                        {/* // onClick={(e) => this.onSort(e,'')}  sorting_asc onClick={(e) => this.onSort(e,'')} */}
                        <table id="data-table" className="table" style={{width:"100%"}}>
                           <thead>
                              <tr>
                                 <th className="width-5-percent center-align">{LBL_SLNUM} </th>            
                                 <th className="width-15-percent" >{LBL_SHIFT_DATE}</th>
                                 <th className="width-20-percent">{LBL_COMPLETED_SHIFT_CREWS}</th>
                                 <th className="width-15-percent">{LBL_CLIENT+'/'+crew_chief_text}</th>
                                 <th className="width-15-percent">{LBL_REVIEWED_BY}</th>
                                 <th className="width-10-percent">{LBL_RATING}</th>
                                 <th className="width-20-percent">{LBL_REVIEW_COMMENTS} </th>   
                              </tr>
                           </thead>
                           <tbody>
                           {(this.state.noRowsFoundMsg && this.state.noRowsFoundMsg.length > 1)  && 
                              <tr>
                                 <td colSpan="7" className="text-center">{MSG_NOT_FOUND}</td>
                              </tr>
                           }
                           { feedbackShiftList.map((item, index)  => {
                              let indexNum = (PAGENUMROWS_AFFILIATE*(activePage-1))+index+1; 
                              let event_start_time = converDateToLocal(item.shift.start_datetime,timeZone.utc_offset,'ddmmyyyyhhmm'); 
                              let event_end_time = converDateToLocal(item.shift.end_datetime,timeZone.utc_offset,'hhmm');  
                              let shiftLength = convertDecimalToHHMM(item.shift.shift_length);
                              let chief_reviews = item.chief_reviews ? item.chief_reviews : []; 
                              // "client_review":{"client_id":431,"client_name":"Brezza","star_rating":5,"review_comment":null}
                              let client_name = item.client_review.client_name ? item.client_review.client_name : ''; 
                              let reviewer_name = item.client_review.reviewer_name ? item.client_review.reviewer_name : '';
                              let star_rating = item.client_review.star_rating ? item.client_review.star_rating : 0;
                              let review_comment = item.client_review.review_comment ? item.client_review.review_comment : '';
                              
                              return (
                                 <React.Fragment key={index}>
                                    {/* <tr className={item.isExpand?'shown':''}> */}
                                    <tr className={item.shift.id===this.state.expandedShiftId?'shown':''}> 
                                        {/* <td className="details-control sorting_1" onClick={(e) => this.onLoadShift(item.shift.id,item.isExpand)}></td> */}
                                        <td className="center-align">{indexNum}</td>
                                        <td>{event_start_time} - {event_end_time} ({shiftLength+' '+LBL_HOURS_SHORT.toLowerCase()})</td>
                                        <td>{item.shift.title+' @ '+item.shift.event_title}</td>
                                        {!isClientPage &&
                                        <td>{client_name}</td>
                                        }
                                        <td>{reviewer_name}</td>
                                        <td>
                                          <div className="crew">
                                            <div className={isClientPage?'crew__rating':'crew__rating rating-display-only'}>
                                            {CREW_MAX_RATING.map(ratingNum => {
                                                if(Number(ratingNum) <= Number(star_rating)) {
                                                    return(
                                                    <React.Fragment key={'ratingshift'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"ratingshift"+item.id+ratingNum} onChange={is_active===true ? (e) => this.onStarRateUpdate(e) : this.justClick()} data-id={ratingNum} data-feedback={item.id} data-type="0" data-shift={item.id} disabled={!isClientPage} /><label htmlFor={"ratingshift"+item.id+ratingNum} className={isClientPage?'client-rate':'affiliate-rate checked-rate'}><i className="fas fa-star"></i></label></React.Fragment>
                                                )
                                                }else {                                                 
                                                    return(
                                                    <React.Fragment key={'ratingshift'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"ratingshift"+item.id+ratingNum} onChange={is_active===true ? (e) => this.onStarRateUpdate(e) : this.justClick()} data-id={ratingNum} data-feedback={item.id} data-type="0" data-shift={item.id} disabled={!isClientPage} /><label htmlFor={"ratingshift"+item.id+ratingNum} className={isClientPage?'client-rate':'affiliate-rate'}><i className="far fa-star"></i></label></React.Fragment>
                                                    )                                                     
                                                }     
                                            })
                                            }                                                
                                            </div>
                                          </div> 
                                        </td> 
                                        <td>
                                          {review_comment}
                                        </td>    
                                        {isClientPage && is_active===true && 
                                        <td className="text-center"> 
                                          {/* <Link to="#" onClick={(e) => this.editFeedBack(e,item.shift.id, item.id,0,0,0)}>{LBL_REVIEW}</Link> */}
                                        </td>
                                        }                                         
                                    </tr> 
                                    {chief_reviews && Array.isArray(chief_reviews) && chief_reviews.length > 0 && chief_reviews.map(crItem => {
                                       return(
                                          <tr>
                                             <td></td><td></td><td></td>
                                             <td>{crew_chief_text}</td>
                                             <td>{crItem.reviewer_name}</td>
                                             <td>
                                                <div className="crew">
                                                   <div className={'crew__rating rating-display-only'}>
                                          
                                                      {CREW_MAX_RATING.map(ratingNum => {
                                                         if(Number(ratingNum) <= Number(crItem.star_rating) ) {
                                                            return(
                                                               <React.Fragment key={'ratingshift'+ratingNum}><input type="checkbox" checked={true} name="rating" id={"ratingshift"+crItem.id+ratingNum}  data-id={ratingNum} data-feedback={crItem.id} data-type="1" data-shift={crItem.shift_id} disabled={true} /><label htmlFor={"ratingshift"+crItem.id+ratingNum} className={isClientPage?'client-rate':'affiliate-rate checked-rate'}><i className="fas fa-star"></i></label></React.Fragment>
                                                            )
                                                         }else {
                                                      
                                                            return(
                                                               <React.Fragment key={'ratingshift'+ratingNum}><input type="checkbox" checked={false} name="rating" id={"ratingshift"+crItem.id+ratingNum}  data-id={ratingNum} data-feedback={crItem.id} data-type="1" data-shift={crItem.shift_id} disabled={true} /><label htmlFor={"ratingshift"+crItem.id+ratingNum} className={isClientPage?'client-rate':'affiliate-rate'}><i className="far fa-star"></i></label></React.Fragment>
                                                            )
                                                            
                                                         }
                                                         
                                                      })
                                                      }                                                
                                                   </div>
                                                </div>
                                             </td>
                                             <td>{crItem.review_comment}</td>
                                          </tr>   
                                          )
                                       })
                                       }
                                    </React.Fragment>                                        
                                    )
                                 })      
                                 }                      
                           </tbody>
                        </table>
                        <Paginator totalPage={totalPage} activePage={activePage} startIndex={startIndex} endIndex={endIndex} onPagePrevious={this.onPagePrevious} onPageUp={this.onPageUp} onPageNext={this.onPageNext}/>
                        <div className="clear-b-scroll-sector">&nbsp;</div>   
                        <div className="clear-b-scroll-sector">&nbsp;</div>   
                        <div className="clear-b-scroll-sector">&nbsp;</div>   
                     </div>
                  </div>   
               </div>
                  
            </div>
         </React.Fragment>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        crewFeedbackData:state.crews.crewFeedbackData,
        status:state.crews.status,
        subactivity:state.crews.subactivity,  
        errorData:state.crews.errorData, 
        totalPage:state.crews.crewFeedbackTotalPage,
        numRows:state.crews.crewFeedbackNumRows,
        count:state.crews.crewFeedbackCount,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        crewFeedbackListAction:crewFeedbackListAction,  
        clearAction:clearAction   
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(CrewFeedback);